import { Icon } from '@leroy-merlin-br/backyard-react'
import { User } from '@leroy-merlin-br/backyard-icons'

import { ChatTyping } from '../../../Icons'
import { Message as MessageType } from '../../types'
import Suggestions from '../Suggestions'
import * as S from './styled'

const Message = ({ message, options, type, ...rest }: MessageType) => {
  return (
    <S.MessageWrapper type={type} {...rest}>
      <S.UserIcon type={type}>
        <Icon
          size="byte"
          role="presentation"
          as={type === 'outcome' ? User : ChatTyping}
        />
      </S.UserIcon>
      <S.BaloonsContainer>
        <S.Baloon type={type}>{message}</S.Baloon>
        {options && <Suggestions options={options} />}
      </S.BaloonsContainer>
    </S.MessageWrapper>
  )
}

export default Message
